import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import useApi from '../../../hooks/useApi';
import { error_alert, success_alert } from '../../../utils';
import { network_tl } from '../../../translations';
import { AiOutlineHeart, AiFillHeart } from 'react-icons/ai';
import { Tooltip } from 'react-tooltip';

const bounceKeyframes = `
  @keyframes bounce {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-5px);
    }
  }
`;

const WishList = ({ id, isWishlisted: wishlist, isDisabled }) => {
  console.log("wishlist", wishlist);
  const [isWishlisted, setIsWishlisted] = useState(wishlist);
  const [loading, setLoading] = useState(false);
  const intl = useIntl();
  const { Axios } = useApi();

  const handleSubmit = async () => {
    setLoading(true);
    try {
      let result = '';
      if (isWishlisted) {
        result = await Axios.post(`api/agency/remove-influencer/${id}`);
      } else {
        result = await Axios.post(`api/agency/wishlist/${id}`);
      }
      success_alert(result.data.description);
      setIsWishlisted(!isWishlisted);
      setLoading(false);
    } catch (e) {
      if (e.response) {
        error_alert(JSON.stringify(e.response.data.description));
      } else {
        error_alert(network_tl(intl));
      }
      setLoading(false);
    }
  };

  return (
    <>
      <style>{bounceKeyframes}</style>

      {loading ? (
        <button
          disabled={loading || isDisabled}
          
          className={`text-3xl ${isDisabled ? 'pointer-events-none' : 'cursor-pointer '}`}
          style={{ animation: 'bounce 0.6s ease-in-out infinite ' }}
        >
          <AiOutlineHeart
            data-tooltip-id="add"
            data-tooltip-content={intl.formatMessage({
              id: 'add_to_favorites',
              defaultMessage: 'Add to favorites',
            })}
            className="text-gray-500"
          />
        </button>
      ) : (
        <button onClick={handleSubmit} disabled={loading || isDisabled} className={`text-3xl ${isDisabled ? 'pointer-events-none' : 'cursor-pointer '}`}
>
          {isWishlisted ? (
            <AiFillHeart
              data-tooltip-id="remove"
              data-tooltip-content={intl.formatMessage({
                id: 'remove_from_favorites',
                defaultMessage: 'Remove from favorites',
              })}
              className="text-red-500"
            />
          ) : (
            <AiOutlineHeart
              data-tooltip-id="add"
              data-tooltip-content={intl.formatMessage({
                id: 'add_to_favorites',
                defaultMessage: 'Add to favorites',
              })}
              className="text-gray-500"
            />
          )}
        </button>
      )}

      {
        !isDisabled &&
        <><Tooltip id="add" /><Tooltip id="remove" /></>
      }
    </>
  );
};

export default WishList;